import { createContext, useContext } from 'react';

import type { MapContext, UseMapContext } from './types';

export const context = createContext<MapContext>({} as MapContext);

const useMapContext: UseMapContext = () => {
    const { features, mapState, markers, options } = useContext(context);

    return {
        context,
        features,
        mapState,
        markers,
        options
    };
};

export default useMapContext;
